<template>
  <div class="colorfule-date-picker" @click="onInput">
    <el-date-picker
      v-show="!forever"
      v-model="values"
      ref="datePicker"
      prefix-icon="null"
      :disabled="disabled"
      :readonly="readonly"
      :type="datePickerType"
      :clearable="clearable"
      :picker-options="options"
      :value-format="formatValue"
      :placeholder="placeholderText"
    />
    <svg-icon
      v-if="!readonly"
      :icon-class="!svgRed?'date_time':'date_time_red'"
      @click="handleClickIcon"
      class="right-icon"
    />

    <el-input v-show="forever" v-model="showForever" :readonly="readonly" />
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
export default {
  name: 'date-picker',
  components: {
    'el-date-picker': DatePicker,
  },

  props: {
    value: [String, Date, Number],
    time: {
      type: Boolean,
      default: false,
      comment: '是否显示时分秒',
    },
    disabled: {
      type: Boolean,
      default: false,
      comment: '是否禁用',
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否完全只读',
    },
    clearable: {
      type: Boolean,
      default: false,
      comment: '是否可以一键清除',
    },
    placeholder: {
      type: String,
      default: '请选择时间',
      comment: 'placeholder提示文本',
    },
    hasForever: {
      type: Boolean,
      default: false,
      comment: '是否显示永久选项',
    },
    options: {
      type: Object,
      default() {
        var _this = this
        _this.hasForever
        return {
          shortcuts: [
            _this.hasForever && {
              text: '永久',
              onClick(picker) {
                _this.forever = true
                picker.$emit('pick', '永久')
              },
            },
            {
              text: '今天',
              onClick(picker) {
                _this.forever = false
                picker.$emit('pick', new Date())
              },
            },
            {
              text: '昨天',
              onClick(picker) {
                _this.forever = false
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24)
                picker.$emit('pick', date)
              },
            },
            {
              text: '一周前',
              onClick(picker) {
                _this.forever = false
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', date)
              },
            },
          ],
        }
      },
      comment: 'date-picker的配置项',
    },
    svgRed: {
      type: Boolean,
      default: false,
      comment: 'SVG的颜色是否用红色',
    },
  },

  computed: {
    values: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val || '')
      },
    },
    datePickerType() {
      return this.time ? 'datetime' : 'date'
    },
    formatValue() {
      return this.time ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
    },
    placeholderText() {
      return this.readonly ? '' : this.placeholder
    },
  },

  data() {
    return {
      // 是否选择永久
      forever: false,
      showForever: '永久',
    }
  },

  watch: {
    value(val) {
      if (val === '永久') {
        this.forever = true
      }
    },
  },

  methods: {
    onInput() {
      if (this.readonly) return
      if (this.forever) {
        this.forever = false
        this.$nextTick(() => {
          this.$refs.datePicker.focus()
        })
      }
    },
    handleClickIcon() {
      this.$refs.datePicker.focus()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
